if (!customElements.get('minico-story-slider')) {
  class MinicoStorySlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-story-track]');
      this.prevButton = this.querySelector('[data-story-prev]');
      this.nextButton = this.querySelector('[data-story-next]');

      if (!this.track) return;

      this.prevButton?.addEventListener('click', () => this.scrollByCard(-1));
      this.nextButton?.addEventListener('click', () => this.scrollByCard(1));
      this.track.addEventListener('scroll', () => this.updateControls(), { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });

      this.updateControls();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
    }

    onResize = () => this.updateControls();

    getCards() {
      return Array.from(this.track.querySelectorAll('[data-story-slide]'));
    }

    scrollByCard(direction) {
      const cards = this.getCards();
      if (!cards.length) return;

      const cardWidth = cards[0].getBoundingClientRect().width;
      const gap = Number.parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 12;
      this.track.scrollBy({
        left: direction * (cardWidth + gap),
        behavior: 'smooth',
      });
    }

    updateControls() {
      if (!this.track) return;

      const maxScroll = Math.max(this.track.scrollWidth - this.track.clientWidth, 0);
      const atStart = this.track.scrollLeft <= 4;
      const atEnd = this.track.scrollLeft >= maxScroll - 4;
      const canScroll = maxScroll >= 4;

      if (this.prevButton) this.prevButton.disabled = atStart || !canScroll;
      if (this.nextButton) this.nextButton.disabled = atEnd || !canScroll;
    }
  }

  customElements.define('minico-story-slider', MinicoStorySlider);
}
